import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import { TeacherProfileService } from '../services/teacher-profile.service';

export function useTeacherProfile() {
  const { environment } = useEnvironmentContext();

  const {
    mutateAsync: changePassword,
    isLoading: isChangePasswordLoading,
    isError: isChangePasswordError,
    isSuccess: isChangePasswordSuccess,
    reset: resetChangePassword,
    error: errorChangePassword,
  } = useMutation(
    ({
      currentPassword,
      password,
      accountName,
      teacherId,
    }: {
      currentPassword: string;
      password: string;
      accountName?: string;
      teacherId?: number;
    }) => {
      return TeacherProfileService.changePassword(
        environment,
        currentPassword,
        password,
        accountName,
        teacherId
      );
    }
  );

  return {
    changePassword,
    isChangePasswordLoading,
    isChangePasswordError,
    isChangePasswordSuccess,
    resetChangePassword,
    errorChangePassword: errorChangePassword as AxiosError,
  };
}
